module.exports = __webpack_public_path__ + "static/media/Inter-SemiBold.cd04cacd.woff2";